export const BUSINESS_SCOPED_PREFIXES = [
  "/app/crm",
  "/app/welcomepage",
  "/app/dashboard/priority-sla",
  "/app/dashboard/inbox-analytics",
  "/app/dashboard/lead-command-centre",
  "/app/catalog",
  "/app/campaigns",
  "/app/messaging",
  "/app/inbox",
  "/app/automation",
  "/app/cta-flow",
  "/app/templatebuilder",
  "/app/template-builder",
  "/app/settings/whatsapp",
  "/app/settings/integrations",
  "/app/settings/website-widget",
  "/app/settings/meta-account",
  "/app/settings/team-management",
  "/app/settings/role-permission-mapping",
  "/app/settings/checkout",
  "/app/settings/password",
];

export function isBusinessScopedPath(pathname) {
  return BUSINESS_SCOPED_PREFIXES.some(prefix =>
    String(pathname || "").startsWith(prefix),
  );
}

// Business work requires Login as Business for superadmin. Keep personal
// password changes and page-local /admin tools in the platform session.
export function requiresBusinessSession(pathname) {
  const path = String(pathname || "").replace(/\/+$/, "");
  const prefixes = [
    ...BUSINESS_SCOPED_PREFIXES.filter(prefix => prefix !== "/app/settings/password"),
    "/app/dashboard",
    "/app/welcome",
    "/app/ai-agent",
    "/app/orders",
    "/app/scheduling",
    "/app/billing",
    "/app/business/pricing",
    "/app/upgrade",
    "/app/integrations",
    "/app/profile-completion",
    "/app/settings/profile-completion",
    "/app/settings/wallet",
    "/app/settings/billing",
    "/app/settings/scheduling",
    "/app/settings/order-policies",
    "/app/settings/order-payments",
    "/app/settings/order-customer-updates",
  ];
  return path === "/app/settings" || prefixes.some(prefix =>
    path === prefix || path.startsWith(`${prefix}/`)
  );
}
